document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  const backdrop = document.querySelector('.nav-backdrop');
  const close = document.querySelector('.nav-close');
  const setMenu = open => {
    if (!menu || !nav) return;
    menu.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open);
    if (backdrop) backdrop.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  };
  if (menu && nav) menu.addEventListener('click', () => {
    setMenu(menu.getAttribute('aria-expanded') !== 'true');
  });
  if (close) close.addEventListener('click', () => setMenu(false));
  if (backdrop) backdrop.addEventListener('click', () => setMenu(false));
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => form.addEventListener('submit', async event => {
    const submitter = event.submitter;
    if (submitter?.name === 'checkout' || submitter?.closest('.shopify-payment-button')) return;
    event.preventDefault();
    const button = submitter || form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;
    const wasDisabled = button?.disabled;
    if (button) button.disabled = true;
    if (button) button.textContent = 'Adding…';
    try {
      const addUrl = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
      const response = await fetch(addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Could not add this item. Please try again.');
      const cartLink = document.querySelector('.cart-link');
      const cartPath = cartLink ? new URL(cartLink.href).pathname : '/cart';
      const cartResponse = await fetch(`${cartPath}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Item added, but the cart count could not be refreshed.');
      const cart = await cartResponse.json();
      const count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = `My Cart: ${cart.item_count} item(s)`;
      if (cartLink) cartLink.dataset.cartItemsCount = String(cart.item_count);
      let toast = document.querySelector('.cart-add-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cart-add-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.append(toast);
      }
      toast.textContent = 'Added to cart. Keep browsing to add more items.';
      toast.classList.add('is-visible');
      window.clearTimeout(window.cartAddToastTimer);
      window.cartAddToastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
    } catch (error) {
      window.alert(error.message || 'Could not add this item. Please try again.');
    } finally {
      if (button) { button.disabled = wasDisabled; button.textContent = originalText; }
    }
  }));
  document.querySelectorAll('.nav-collection-trigger').forEach(link => link.addEventListener('click', event => event.preventDefault()));
  document.querySelectorAll('.submenu-toggle').forEach(button => button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    const submenu = button.nextElementSibling; if (submenu) submenu.classList.toggle('is-open', open);
  }));
  const formatCartMoney = (cents, format) => {
    const amount = (Number(cents) / 100).toFixed(2);
    const thousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDecimals = Math.round(Number(cents) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountComma = amount.replace('.', '#').replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace('#', ',');
    const noDecimalsComma = noDecimals.replace(/,/g, '.');
    const values = {
      amount: thousands,
      amount_no_decimals: noDecimals,
      amount_with_comma_separator: amountComma,
      amount_no_decimals_with_comma_separator: noDecimalsComma,
      amount_with_apostrophe_separator: amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
      amount_no_decimals_with_comma_separator: noDecimalsComma
    };
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (token, key) => values[key] ?? token);
  };
  document.querySelectorAll('[data-cart-quantity-change]').forEach(button => button.addEventListener('click', async () => {
    const input = button.parentElement.querySelector('input[name="updates[]"]');
    const form = button.closest('.cart-form');
    const page = button.closest('.cart-page');
    const line = button.closest('[data-cart-line]');
    if (!input || !form || !page || !line || form.dataset.updating === 'true') return;
    const quantity = Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQuantityChange));
    const previousQuantity = Number(input.value || 0);
    const controls = form.querySelectorAll('[data-cart-quantity-change], input[name="updates[]"]');
    form.dataset.updating = 'true';
    controls.forEach(control => { control.disabled = true; });
    input.value = quantity;
    try {
      const changeUrl = `${page.dataset.cartChangeUrl || '/cart/change'}.js`;
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams({ line: line.dataset.cartLine, quantity: String(quantity) })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Could not update the cart. Please try again.');
      const itemByKey = new Map(cart.items.map(item => [item.key, item]));
      let nextLineNumber = 0;
      page.querySelectorAll('[data-cart-line]').forEach(cartLine => {
        const item = itemByKey.get(cartLine.dataset.cartKey);
        if (!item) {
          cartLine.remove();
          return;
        }
        cartLine.dataset.cartLine = String(++nextLineNumber);
        const quantityInput = cartLine.querySelector('input[name="updates[]"]');
        if (quantityInput) quantityInput.value = item.quantity;
        const total = cartLine.querySelector('.cart-line-total');
        if (total) total.textContent = formatCartMoney(item.final_line_price, page.dataset.moneyFormat);
      });
      const subtotal = page.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatCartMoney(cart.total_price, page.dataset.moneyFormat);
      const pageCount = page.querySelector('.cart-count');
      if (pageCount) pageCount.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
      const headerCount = document.querySelector('[data-cart-count]');
      if (headerCount) headerCount.textContent = `My Cart: ${cart.item_count} item(s)`;
      const cartLink = document.querySelector('.cart-link');
      if (cartLink) cartLink.dataset.cartItemsCount = String(cart.item_count);
      if (cart.item_count === 0) {
        const emptyTemplate = page.querySelector('[data-cart-empty-template]');
        form.after(emptyTemplate.content.cloneNode(true));
        form.remove();
      }
    } catch (error) {
      input.value = previousQuantity;
      window.alert(error.message || 'Could not update the cart. Please try again.');
    } finally {
      if (form.isConnected) {
        form.dataset.updating = 'false';
        form.querySelectorAll('[data-cart-quantity-change], input[name="updates[]"]').forEach(control => { control.disabled = false; });
      }
    }
  }));
  const productLimit = document.querySelector('[data-collection-limit]');
  const productGrid = document.querySelector('[data-collection-grid]');
  const productCount = document.querySelector('[data-collection-count]');
  if (productLimit && productGrid) {
    const cards = Array.from(productGrid.querySelectorAll('.product-card'));
    const allowed = ['4', '6', '8'];
    const params = new URLSearchParams(window.location.search);
    const initial = allowed.includes(params.get('limit')) ? params.get('limit') : '4';
    productLimit.value = initial;
    const applyLimit = value => {
      const limit = Number(value);
      cards.forEach((card, index) => { card.hidden = index >= limit; });
      if (productCount) productCount.textContent = `1 – ${Math.min(limit, cards.length)} product(s) of ${productGrid.dataset.total || cards.length}`;
    };
    productGrid.dataset.total = productGrid.dataset.total || String(cards.length);
    applyLimit(initial);
    productLimit.addEventListener('change', () => {
      params.set('limit', productLimit.value);
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      applyLimit(productLimit.value);
    });
  }
});

